import React from "react";
import {
    Menu,
    Typography, Divider
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {MenuBarComp} from "../components/menu-bar-comp";

const MenuBarPopup = ({anchorEl, onClose, tenantType}) => {
    const {t} = useTranslation();
    return (

        <Menu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            PaperProps={{style: {width: "200px"}}}
        >
            <Typography variant="h6" sx={{mb: 1, marginLeft: 2, fontWeight: "bold"}}>
                {t("Overview")}
            </Typography>
            <Divider/>
            <MenuBarComp tenantType={tenantType}/>
        </Menu>

    );
};

export default MenuBarPopup;
